module.exports = __webpack_public_path__ + "static/media/box-check.dbfb260f.svg";